<template>
    <div class="container">
        <div class="handle-box-search">
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="name" label="合作商名称" min-width="150"> </el-table-column>

            <el-table-column prop="order_mode_name" label="订单模式" min-width="150"> </el-table-column>

            <el-table-column prop="appoint_driver" label="是否指定司机" min-width="150"> </el-table-column>

            <el-table-column prop="appid" label="appid" min-width="150"> </el-table-column>

            <el-table-column prop="appid" label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-button @click="addDriver(scope.row.appid)" type="primary">添加指定司机</el-button>
                </template>
            </el-table-column>
        </el-table>

        <addDriver :isShow="edit_isShow" @onSubmit="cooperatorLists" :data="edit_data"></addDriver>
    </div>
</template>

<script>
import addDriver from './addDriver';

var _this;
import bus from '@/components/common/bus';
export default {
    components: {
        addDriver
        // editCoupon
    },
    data() {
        return {
            edit_isShow: false,

            edit_data: '',

            // 存放表格数据
            tableData: []
        };
    },
    created() {
        _this = this;

        _this.cooperatorLists();
    },

    methods: {
        addDriver(appid) {
            _this.edit_isShow = !_this.edit_isShow;
            _this.edit_data = appid;
        },

        // 搜索用户管理列表
        cooperatorLists() {
            _this
                .$post('/cooperator/list')
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
